<template>
    <div class="contain desFile">
        <div class="header-box">
            <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
        </div>
        <div class="box">
            <div class="build-bar" style="height:auto;flex-wrap:wrap;padding-top:10px;padding-bottom: 10px;border-bottom:1px solid #ddd;">
                <!-- <el-button v-for="item in bars" :key="item.id" style="margin:5px 10px;" :class="cuid==item.id?'primary':''" @click="setCuid(item)">{{item.name}}</el-button> -->
                <div v-for="item in bars" :key="item.id">
                    <el-popover
                    placement="right"
                    width="400"
                    trigger="hover">
                        <el-table :data="item.list" :show-header="false">
                            <el-table-column prop="name" label="" width="200"></el-table-column>
                            <el-table-column prop="count" label=""></el-table-column>
                            <!-- <el-table-column prop="completeType" label="">
                                <template slot-scope="scope">
                                    <el-badge v-if="scope.row.completeType=='1'" is-dot class="btn-dot mid-dot yellow" />
                                    <el-badge v-else-if="scope.row.completeType=='2'" is-dot class="btn-dot mid-dot green" />
                                    <el-badge v-else is-dot class="btn-dot mid-dot red" />
                                </template>
                            </el-table-column> -->
                        </el-table >
                        <el-button slot="reference" style="margin:5px 10px;" :class="cuid==item.id?'primary':''" @click="setCuid(item)">
                            {{item.name}} 
                            <!-- <el-badge is-dot class="btn-dot" :class="{'red':!item.completeType||item.completeType=='0', 'yellow':item.completeType=='1', 'green':item.completeType=='2'}" /> -->
                        </el-button>
                    </el-popover>
                </div>
            </div>
            <div class="build-bar" style="height:100px;flex-wrap:wrap;justify-content: flex-end;align-items: center;">
              <el-upload
                v-if="cuid=='27'||cuid=='28'||cuid=='29'"
                class="upload-demo"
                v-bind:action="uploadUrl"
                :headers="uploadHead"
                :data={type:213}
                multiple
                objectBind='1'
                :show-file-list="false"
                :on-success="fileSuccess1">
                    <i class="el-icon-upload" style="color:#36C635;font-size:56px;"></i>
                    <div class="el-upload__text">上传</div>
              </el-upload>
              <div  style="display:flex;flex-wrap:wrap;justify-content: center;margin:0 10px;cursor: pointer;" @click="showModel(2)">
                  <img style="width:64px;height:64px;" src="../../../assets/image/file.png" />
                  <p style="width:100%;margin:0">原件文档</p>
              </div>
              <div style="display:flex;flex-wrap:wrap;justify-content: center;margin:0 10px;cursor: pointer;" @click="showModel(1)">
                  <img style="width:64px;height:64px;" src="../../../assets/image/file.png" />
                  <p style="width:100%;margin:0">模板文档</p>
              </div>
              <el-button type="success" v-if="cuid=='30'||cuid=='31'||cuid=='32'" @click="exportTable" style="margin-right:20px;background:#67c23a;color:#fff;">导出表格</el-button>
              <!-- <el-button type="success" v-if="cuid=='32'" @click="badVisible=true" style="margin:20px 0;background:#17b2fe;color:#fff;">新增清单</el-button> -->
            </div>
            <div class="box-content flex-wrap" v-if="cuid=='27'||cuid=='28'||cuid=='29'">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60" type="index">
                    </el-table-column>
                    <el-table-column label="文件名">
                        <template slot-scope="scope">
                            <span :title="scope.row.attachmentName">{{ scope.row.attachmentName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="文件格式">
                        <template slot-scope="scope">
                            <!-- <span>{{ scope.row.changeDescribe }}</span> -->
                            <img v-if="scope.row.fileType=='1'" style="width:50px;height:50px;" src="../../../assets/image/office/word.png" @click="showFile(scope.row.attachment,scope.row.attachmentName)" />
                            <img v-else-if="scope.row.fileType=='2'" style="width:50px;height:50px;" src="../../../assets/image/office/excel.png" @click="showFile(scope.row.attachment,scope.row.attachmentName)" />
                            <img v-else-if="scope.row.fileType=='3'" style="width:50px;height:50px;" src="../../../assets/image/office/pdf.png" @click="showFile(scope.row.attachment,scope.row.attachmentName)" />
                            <img v-else-if="scope.row.fileType=='4'" style="width:50px;height:50px;" src="../../../assets/image/office/photo.png" @click="showFile(scope.row.attachment,scope.row.attachmentName)" />
                            <img v-else-if="scope.row.fileType=='5'" style="width:50px;height:50px;" src="../../../assets/image/office/undefined.png" @click="showFile(scope.row.attachment,scope.row.attachmentName)" />
                        </template>
                    </el-table-column>
                    <el-table-column label="上传人员">
                        <template slot-scope="scope">
                            <span>{{ scope.row.userName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="上传时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="签证文件">
                        <template slot-scope="scope">
                            <span v-if="scope.row.qzwj=='暂无'">{{ scope.row.qzwj }}</span>
                            <span v-else style="color:#36C635">{{ scope.row.qzwj }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div style="width:100%;height:100%;display: flex;justify-content: space-around;align-items: center;">
                                <img src="../../../assets/image/down.png" style="width:30px;height:30px;cursor: pointer;" @click="downFile(scope.row.attachment)" />
                                <el-button type="text" @click="handleDel(scope.$index, scope.row.id)" style="border:0;color:red;">删除</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="box-content flex-wrap" v-else-if="cuid=='30'||cuid=='31'||cuid=='32'">
                <div class="box-content-tab" style="background: #fff;">
                    <div class="table-left">
                        <div class="table-body-cell1">序号</div>
                        <div class="table-body-cell1"> 变更名称 </div>
                        <div class="table-body-cell1">文件格式</div>
                    </div>
                    <div class="table-right">
                        <div class="table-body-cell2">签证文件</div>
                        <div class="table-body-cell2">文件格式</div>
                        <div class="table-body-cell2">上传人员</div>
                        <div class="table-body-cell2">上传时间</div>
                        <div class="table-body-cell2">操作</div>
                    </div>
                </div>
                <div class="box-content-tab" v-for="item in listData" :key="item.id">
                    <div class="table-left">
                        <div class="table-body-cell1">{{item.index}}</div>
                        <div class="table-body-cell1 nowrap" :title="item.attachmentName"><span class="nowrap" style="width:100%;">{{item.attachmentName}}</span></div>
                        <div class="table-body-cell1">
                            <img v-if="item.fileType=='1'" style="width:50px;height:50px;" src="../../../assets/image/office/word.png" @click="showFile(item.attachment,item.attachmentName)" />
                            <img v-else-if="item.fileType=='2'" style="width:50px;height:50px;" src="../../../assets/image/office/excel.png" @click="showFile(item.attachment,item.attachmentName)" />
                            <img v-else-if="item.fileType=='3'" style="width:50px;height:50px;" src="../../../assets/image/office/pdf.png" @click="showFile(item.attachment,item.attachmentName)" />
                            <img v-else-if="item.fileType=='4'" style="width:50px;height:50px;" src="../../../assets/image/office/photo.png" @click="showFile(item.attachment,item.attachmentName)" />
                            <img v-else-if="item.fileType=='5'" style="width:50px;height:50px;" src="../../../assets/image/office/undefined.png" @click="showFile(item.attachment,item.attachmentName)" />
                        </div>
                    </div>
                    <div class="table-right" v-if="item.attachment1&&item.attachment1!=''">
                        <div class="table-body-cell2" :title="item.attachmentName1"><span class="nowrap" style="width:100%;">{{item.attachmentName1}}</span></div>
                        <div class="table-body-cell2">
                            <img v-if="item.fileType1=='1'" style="width:50px;height:50px;" src="../../../assets/image/office/word.png" @click="showFile(item.attachment1,item.attachmentName1)" />
                            <img v-else-if="item.fileType1=='2'" style="width:50px;height:50px;" src="../../../assets/image/office/excel.png" @click="showFile(item.attachment1,item.attachmentName1)" />
                            <img v-else-if="item.fileType1=='3'" style="width:50px;height:50px;" src="../../../assets/image/office/pdf.png" @click="showFile(item.attachment1,item.attachmentName1)" />
                            <img v-else-if="item.fileType1=='4'" style="width:50px;height:50px;" src="../../../assets/image/office/photo.png" @click="showFile(item.attachment1,itemattachmentName1)" />
                            <img v-else-if="item.fileType1=='5'" style="width:50px;height:50px;" src="../../../assets/image/office/undefined.png" @click="showFile(item.attachment1,item.attachmentName1)" />
                        </div>
                        <div class="table-body-cell2">{{item.userName1}}</div>
                        <div class="table-body-cell2">{{item.createDate1}}</div>
                        <div class="table-body-cell2 flex-btwen">
                            <img src="../../../assets/image/downfile.png" style="width:30px;height:30px;cursor: pointer;" @click="downFile(item.attachment1)" />
                            <el-button type="text" @click="handleDel(item.index, item.id1)" style="border:0;color:red;">删除</el-button>
                        </div>
                    </div>
                    <div class="table-right" v-else>
                        <div style="background: #fff;display:flex;justify-content: flex-end;width:100%;height:100%;">
                            <div class="table-body-cell2">
                                <el-upload
                                    class="upload-demo"
                                    v-bind:action="uploadUrl"
                                    :headers="uploadHead"
                                    :data={type:213}
                                    :objectBind='item.id'
                                    :show-file-list="false"
                                    :on-success="fileSuccess2">
                                        <i class="el-icon-upload" style="color:#36C635;font-size:56px;"></i>
                                        <div class="el-upload__text">上传</div>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="box-content flex-wrap" v-else-if="cuid=='32'" style="height: calc( 100% - 155px );">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="60" type="index">
                    </el-table-column>
                    <el-table-column label="描述">
                        <template slot-scope="scope">
                            <span>{{ scope.row.note }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="文件名">
                        <template slot-scope="scope">
                            <span>{{ scope.row.attachmentName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="时间">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="setOneFile(scope.row)">跳转至变更项明细</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div> -->
            <!-- 新增窗口 -->
            <el-dialog
                title="添加负面清单"
                width="500px"
                :visible.sync="badVisible"
                center
                :append-to-body="true"
                :lock-scroll="false"
                class="add-form"
            >
                <el-form :model="addForm" ref="addForm" label-width="100px" :label-position="labelPosition">
                    <el-form-item label="文件：">
                         <el-select v-model="addForm.id" filterable clearable placeholder="请选择">
                            <el-option
                            v-for="item in files"
                            :key="item.id"
                            :label="item.attachmentName"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="描述：">
                        <el-input v-model="addForm.note" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="badVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddBad">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            pageTitle:'',
            labelPosition:'right',
            listData:[],
            groupId:"",
            bars:base.change,
            cuid:'',
            curFile:{
                type:'',
                materiaType:'',
                groupId:'',
                entProjectId:'',
                attachment:'',
                attachmentName:'',
                attachmentType:'',
                userId:'',
                userName:'',
            },
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            entProjectId:'',
            dataList:[],
            pdfDoc: null,
            fileName:'',
            wordUrl:'',//word文档地址
            dataText:"数据加载中...",
            badVisible:false,//展示负面清单显示标识
            files:[],//选择文件列表
            addForm:{
                id:'',
                note:''
            },
            isFirstCreate:false, //第一个文件是否正在上传
        }
    },
    mounted() {
        this.groupId = this.$store.state.groupId;
        if(''==this.groupId){
            this.$store.commit('setGroupId');
            this.groupId = this.$store.state.groupId;
        }
        this.entProjectId = this.$route.params.id
        this.fixCuid()
        this.getData()
        this.getTotalData()
    },
    methods:{
        //确定cuid
        fixCuid(){
            var cuid = util.session.get('cuid')
            var result = ''
            for(var i=0;i<this.bars.length;i++){
                if(cuid==this.bars[i].id){
                    result = this.bars[i].id
                }
            }
            if(result==''){
                this.cuid = base.pdm.length+base.trans.length+base.maint.length+1
            }else{
                this.cuid = cuid
            }
        },
        //获取数据
        getData(){
            var that = this
            myHttp.getBianGen({
                type:this.cuid,
                // groupId:this.groupId,
                entProjectId:this.entProjectId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    that.pageTitle = resp.data.data.EntProject.name
                    var list = resp.data.data.AttachmentType||[]
                    for(var i=0;i<list.length;i++){
                        list[i].fileType = that.getImg(list[i].attachment)
                        list[i].index = i+1
                    }
                    that.listData = list
                    if(list.length==0){
                        that.dataText = "暂无数据"
                    }
                }else{
                    that.$message.error(resp.data.msg);
                }
                
            },function(){})
        },
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        // handleEdit(index,row){
        //     this.$router.push('/overFileSec/'+this.entProjectId+'/'+this.cuid+'/'+row.id)
        // },
        //删除
        handleDel(index,id){
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteAttachment({
                    id:id
                }).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message({type: 'success',message: '操作成功!'});
                        if(that.cuid=='27'||that.cuid=='28'||that.cuid=='29'){
                            that.getData()
                        }else{
                            that.getListData()
                        }
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            })
        },
        
        //展示
        setCuid(row){
            this.cuid = row.id
            this.listData = []
            util.session.set('cuid',this.cuid)
            if(row.id=='27'||row.id=='28'||row.id=='29'){
                this.getData()
            }else{
                this.getListData()
            }
            
        },
        //获取变更签证数据
        getListData(){
            var that = this
            var attachmentType = ''
            if(this.cuid=='31'){
                attachmentType = 2
            }else if(this.cuid=='30'){
                attachmentType = 1
            }else if(this.cuid=='32'){
                attachmentType = 3
            }
            myHttp.getQianZi({
                type:this.cuid,
                entProjectId:this.entProjectId,
                attachmentType:attachmentType
            }).then(function(resp){
                var list = resp.data.data.AttachmentType||[]
                that.files = list
                // if(that.cuid=='32'){
                //     var data = []
                //     for(var i=0;i<list.length;i++){
                //         if(list[i].note&&list[i].note!=''){
                //             list[i].index = i+1
                //             data.push(list[i])
                //         }
                //     }
                //     that.listData = data
                // }else{
                    for(var i=0;i<list.length;i++){
                        list[i].fileType = that.getImg(list[i].attachment)
                        list[i].index = i+1
                        list[i].fileType1 = list[i].attachment1?that.getImg(list[i].attachment1):''
                    }
                    that.listData = list
                //}
                if(that.listData.length==0){
                    that.dataText = "暂无数据"
                }
                
            },function(){})
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        /**申报材料 */
        //上传成功
        fileSuccess1(res,file,opt,index){
            if(res.code==200){
                // this.curFile.type = this.cuid
                // this.curFile.materiaType = index
                // this.curFile.groupId = this.groupId
                // this.curFile.entProjectId = this.entProjectId
                // this.curFile.attachment = res.data.saveUrls
                var name = file.name.split('.')
                name.pop()
                name = name.join();
                // this.curFile.attachmentName = name
                // this.curFile.userId = this.$store.state.user.id
                // this.curFile.userName = this.$store.state.user.name
                // this.curFile.attachmentType = 3
                // this.submitFun(this.curFile)
                var obj = {
                    type:this.cuid,
                    materiaType:index,
                    groupId:this.groupId,
                    entProjectId:this.entProjectId,
                    attachment:res.data.saveUrls,
                    attachmentName:name,
                    userId:util.session.get('user').id,
                    userName:util.session.get('user').name,
                    attachmentType:3
                }

                if(this.isFirstCreate){
                    var that = this
                    setTimeout(function(){
                        that.submitFun(obj)
                    },1000)
                }else{
                    this.submitFun(obj)
                }
                
            }else{
                this.$message.error(res.msg);
            }
        },

        /**
         * 提交签证
         */
        fileSuccess2(res,file,opt,index){
            if(res.code==200){
                var name = file.name.split('.')
                name.pop()
                name = name.join();
                var obj = {
                    parentId:index,
                    attachment:res.data.saveUrls,
                    attachmentName:name,
                    attachmentType:3,
                    userId:this.$store.state.user.id,
                    userName:this.$store.state.user.name,
                    visaType:1
                }
                if(this.cuid=='30'){
                    obj.visaType = 1
                }else if(this.cuid=='31'){
                    obj.visaType = 2
                }else if(this.cuid=='32'){
                    obj.visaType = 3
                }
                var that = this
                myHttp.postBianGen(obj).then(function(resp){
                    if(resp.data.code=='200'){
                        that.$message({type: 'success',message: '文件添加成功!'});
                        that.getListData()
                    }else{
                        that.$message.error(resp.data.msg);
                    }
                },function(){})
            }else{
                this.$message.error(res.msg);
            }
            
        },

        /**
         * 添加方法
         */
        submitFun(data){
            let that = this
            // window.open(base.fileView+'/addTask?url='+base.httpCtx+data.attachment);
            this.isFirstCreate = true
            myHttp.postAttachment(data).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message({type: 'success',message: '文件添加成功!'});
                    that.getData()
                    that.isFirstCreate = false
                }else{
                    that.$message.error(resp.data.msg);
                    that.isFirstCreate = false
                }
            })
        },
        //查看文档
        showFile(url,name){
            var that = this
            window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+url),"_blank");
            
        },
        //下载文档
        downFile(url){
            window.open(base.httpCtx+url)
        },
        //查看模板
        showModel(type){
            this.$router.push('/folder/'+this.cuid+'/1/'+type+'/'+this.entProjectId)
        },

        //导出表格
        exportTable(){
            var token = this.$store.state.token;
            var attachmentType = ''
            if(this.cuid=='31'){
                attachmentType = 2
            }else if(this.cuid=='30'){
                attachmentType = 1
            }
            window.open(myHttp.exportChangeFile+'?entProjectId='+this.entProjectId+'&type='+this.cuid+'&attachmentType='+attachmentType+'&accessToken='+token)
        },

        //跳转至当前项
        setOneFile(obj){
            var list = []
            obj.index = 1
            obj.fileType = this.getImg(obj.attachment)
            list.push(obj)
            this.listData = list
            this.cuid = obj.type
        },

        //添加清单
        sumbitAddBad(){
            var that = this
            if(this.addForm.id==''){
                this.$message.error('请选择文件');
                return
            }
            if(this.addForm.note==''){
                this.$message.error('请输入描述');
                return
            }
            var obj = {
                id:this.addForm.id,
                note:this.addForm.note
            }
            myHttp.updateAttachment(obj).then(function(resp){
                if(resp.data.code=='200'){
                    that.badVisible = false
                    that.$message({type: 'success',message: '负面清单添加成功!'});
                    that.getListData()
                }else{
                    that.$message.error(resp.data.msg);
                }
            },function(){})
        },


        /**
         * 获取弹出框数据统计
         */
        getTotalData(){
            var that = this
            var types = ''
            for(var i=0;i<this.bars.length;i++){
                if(types==''){
                    types = this.bars[i].id
                }else{
                    types += ','+this.bars[i].id
                }
            }
            myHttp.statisticalAttachmentType({
                types:types,
                groupId:this.groupId,
                entProjectId:this.entProjectId,
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.AttachmentType||[]
                    var barsList = that.bars
                    that.bars = []
                    for(var i=0;i<list.length;i++){
                        barsList[i].completeType = list[i].completeType && ''!=list[i].completeType?list[i].completeType:'0'
                        barsList[i].list = []
                        var obj = {
                            name:'总数',
                            completeType: list[i].list.length>0?list[i].list[0].completeType:'0',
                            count: list[i].list.length>0?list[i].list[0].count:0,//str.count||0,
                        }
                        barsList[i].list.push(obj)

                        // for(var j=0;j<child.length;j++){
                        //     var str = that.getInfoByCuid(child[j].id,list[i].list)
                        //     var obj = {
                        //         name:child[j].name,
                        //         completeType: str.completeType||'',
                        //         count: str.count||0,
                        //         materiaType: child[j].id
                        //     }
                        //     barsList[i].list.push(obj)
                        // }
                        // barsList[i].list = child
                    }
                    that.bars = barsList
                }
            })
        },

        //根据cuid和type获取名称
        // getInfoByCuid(id,list){
        //     var str = {}
        //     for(var i=0;i<list.length;i++){
        //         if(id==list[i].materiaType){
        //             str = list[i]
        //         }
        //     }
        //     return str
        // },
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #2058D9;
    }
    .box{
        margin-top: 15px;
        width: 100%;
        height: calc( 100% - 85px );
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 190px );
        /* background: #fff; */
        overflow: auto;
        display: flex;
        align-content: flex-start;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    .el-button{
        background: #FFF;
        border: 1px solid #DCDFE6;
        color: #606266;
    }
    .primary{
        background-color: #17b2fe;
        border-color: #17b2fe;
        color: #fff;
    }
    .table-item{
        width: 100%;
        min-height: 50px;
        display: flex;
        border-bottom: 15px solid #ecf0f5;
        background: #fff;
    }
    .flex-wrap{
        display: flex;
        flex-wrap: wrap;
    }
    .item-con{
        padding: 10px;
    }
    .item-con p{
        margin: 0;
        margin-bottom: 15px;
        width: 100%;
        text-align: center;
        font-size: 14px;
    }
    .item-con img{
        cursor: pointer;
    }
    .table-item-sec{
        width: 100%;
        height: 50px;
        background: #17B2FE;
        color: #fff;
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 15px solid #ecf0f5;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .file-other{
        width:100%;
        height:80px;
        background:#4D7BF4;
        color:#fff;
        border-bottom: 15px solid #ecf0f5;
        display: flex;
        align-items: center;
        padding: 0 20px;
        font-size: 20px;
        justify-content: space-between;
        box-sizing: border-box;
        cursor: pointer;
    }
    .box-content-tab{
        width: 100%;
        height: 80px;
        display: flex;
        margin: 5px 0;
        position: relative;
    }
    /* .table-head-cell{
        width: 12.5%;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    } */
    .table-left{
        position: relative;
        width: 38.4%;
        height: 100%;
        padding-right: 10px;
        display: flex;
    }
    .table-right{
        position: relative;
        width: 61.6%;
        height: 100%;
        padding-left: 10px;
        display: flex;
    }
    .table-body-cell1{
        width: 33.33%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    }
    .table-body-cell2{
        width: 20%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    }
    .flex-btwen{
        display: flex;
        justify-content: space-around;
    }
    /*不换行（span）*/
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    .el-table td, .el-table th{
        text-align: center;
    }
    /* .el-dialog{
        width: 500px;
    } */
    .btn-dot .is-dot{
        top: 2px;
        width: 12px;
        height: 12px;
    }
    .green .is-dot{
        background-color: #67C23A;
    }
    .yellow .is-dot{
        background-color: #E6A23C;
    }
    .red .is-dot{
        background-color: #F56C6C;
    }
    .mid-dot{
        top: 4px;
    }
    .desFile .box-content .el-tabs__content{
        height: calc( 100% - 40px );
        overflow: auto;
    }
    .desFile .box-content .el-tab-pane{
        height: 100%;
    }
    .box-content .el-tabs__item{
        margin-right: 10px;
        background: #eee;
    }
</style>